module.exports = __webpack_public_path__ + "static/img/getmoney.799ce21.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/getmoney.png
// module id = YVO5
// module chunks = 2